export default __webpack_public_path__ + "1cbfc636c911faa4d0ca77e4b4f90f72.woff2";